import { render, staticRenderFns } from "./SIdentify.vue?vue&type=template&id=0e65b908&scoped=true&"
import script from "./SIdentify.vue?vue&type=script&lang=js&"
export * from "./SIdentify.vue?vue&type=script&lang=js&"
import style0 from "./SIdentify.vue?vue&type=style&index=0&id=0e65b908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65b908",
  null
  
)

export default component.exports